import AudioChain from '../../core/AudioChain';
import * as Tone from 'tone';
import AudioEffect from './AudioEffect';
class AudioEffectRack extends AudioEffect {
    constructor() {
        super(...arguments);
        this.chains = [];
        this.inputGain = new Tone.Gain(0, "decibels");
        this.outputGain = new Tone.Gain(0, "decibels");
    }
    input() { return this.inputGain; }
    output() { return this.outputGain; }
    chain(index) {
        if (!(this.chains[index] instanceof AudioChain)) {
            const chain = new AudioChain();
            this.input().connect(chain.input());
            chain.output().connect(this.output());
            this.chains[index] = chain;
        }
        return this.chains[index];
    }
}
export default AudioEffectRack;
//# sourceMappingURL=AudioEffectRack.js.map